import { render, staticRenderFns } from "./nutrition-step-five.html?vue&type=template&id=4e9dbd47&scoped=true&"
import script from "./nutrition-step-five.js?vue&type=script&lang=js&"
export * from "./nutrition-step-five.js?vue&type=script&lang=js&"
import style0 from "./nutrition-step-five.scss?vue&type=style&index=0&id=4e9dbd47&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9dbd47",
  null
  
)

export default component.exports